import { useEffect, useState } from "react";
import { Button } from "./ui/Button";
import { PrimaryButton } from "./ui/PrimaryButton";
import { EmailInput } from "./ui/EmailInput";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";
import {
  Text,
  Anchor,
  Paper,
  Title,
  Group,
  Grid,
  Center,
  Space,
} from "@mantine/core";
import { Logo } from "./Logo";
import { domain1, domain2, goLoginClickHandler } from "../utils/common";

export const Recover = ({ isDev = false }) => {
  const isMobile = !useMediaQuery("(min-width: 750px)");
  const langs = isDev ? {} : window.getLangs();
  const [currentMailPath, setCurrentMailPath] = useState(domain1);

  const loginId = "res_login_name";
  const form = useForm({
    initialValues: {
      login: "",
      termsOfService: true,
      password: "",
    },
  });

  const handleFormAction = () => {};

  useEffect(() => {
    window.console.log(333, langs);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        background: "#e8e8e8",
        minHeight: "100vh",
        backgroundImage: isMobile ? "" : "url(./background.jpg)",
        backgroundSize: "cover",
      }}
    >
      <form
        onSubmit={form.onSubmit(handleFormAction)}
        autocomplete="off"
        style={{
          margin: isMobile ? "50px auto 0" : "auto",
          width: isMobile ? "100%" : "auto",
        }}
      >
        <Paper
          radius={isMobile ? 0 : 24}
          p={"12px 35px 30px"}
          miw={isMobile ? "100%" : "450px"}
          style={{
            background: "#e8e8e8",
            boxShadow: isMobile ? "" : "0 0 30px 0 rgba(0,0,0,0.3)",
          }}
        >
          <Logo />
          <Grid>
            <Center>
              <Title
                className="no_select"
                style={{ fontWeight: 600, cursor: "default" }}
                order={1}
                ml={5}
                align="left"
                mt="md"
                mb={20}
              >
                {langs["forgot_password_button"] ?? "Forgot password?"}
              </Title>
            </Center>
          </Grid>
          <Group position="apart" mb={0}>
            <Text component="label" sx={{ fontSize: "15px" }} weight={700}>
              {langs["mail"] ?? "Your mail login"}
            </Text>
            <Anchor
              href="#"
              onClick={() => {
                setCurrentMailPath(
                  currentMailPath !== domain2 ? domain2 : domain1
                );
              }}
              sx={() => ({
                color: "#2275e2",
                fontWeight: 700,
                fontSize: "15px",
              })}
            >
              {currentMailPath !== domain2 ? domain2 : domain1}
            </Anchor>
          </Group>
          <EmailInput
            id={loginId}
            form={form}
            formFieldName="login"
            rightText={currentMailPath}
            placeholder={langs["mail"] ?? "Your login"}
          />
          <Space mt="xl" />
          <Grid mt={24}>
            <Grid.Col span={12}>
              <PrimaryButton
                onClick={() => window.sendRecoverForm(langs)}
                fullWidth
                disabled={!form.values.login.length}
              >
                {langs["recover_button"] ?? "Recover"}
              </PrimaryButton>
            </Grid.Col>
            <Grid.Col span={12}>
              <Button onClick={goLoginClickHandler} fullWidth>
                {langs["login_title"] ?? "Login"}
              </Button>
            </Grid.Col>
          </Grid>
          <Space mt="md" />
        </Paper>
      </form>
    </div>
  );
};
